import inRange from "lodash/inRange";
import memoize from "lodash/memoize";
import moment from "moment";

import getLastItem from "utils/activityFeed/lastItem";

const activityLevelFlex = memoize((daysAgo) => {
  if (inRange(daysAgo, 0, 4)) return "highest";
  if (inRange(daysAgo, 4, 8)) return "high";
  if (inRange(daysAgo, 8, 11)) return "medium";
  if (inRange(daysAgo, 11, 21)) return "low";

  return "lowest";
});

const activityLevelLeasing = memoize((daysAgo) => {
  if (inRange(daysAgo, 0, 15)) return "highest";
  if (inRange(daysAgo, 15, 31)) return "high";
  if (inRange(daysAgo, 31, 46)) return "medium";
  if (inRange(daysAgo, 46, 61)) return "low";

  return "lowest";
});

const color = memoize((level) => {
  const colors = {
    highest: () => "#2A8686",
    high: () => "#46E0B5",
    medium: () => "#B8C6D0",
    low: () => "#C987D7",
    lowest: () => "#F75258",
    default: () => "",
  };

  return (colors[level] || colors.default)();
});

const activityLevelColor = (resource, companyType) => {
  const lastItem = getLastItem(resource);
  const date = lastItem && lastItem.createdAt;
  const daysAgo = date && moment().diff(moment(date).startOf("day"), "days");

  const level = companyType === "flex" ? activityLevelFlex(daysAgo) : activityLevelLeasing(daysAgo);

  return color(level);
};

export default activityLevelColor;
